import DetailAction from "@src/components/DetailAction";
import DeleteCodeDialog from "@src/components/dialogs/deleteDialog/DeleteCodeDialog";
// eslint-disable-next-line @comet/no-private-sibling-import
import { StyledTypography } from "@src/components/dialogs/Dialog.sc";
import ReadOnlyDetailField from "@src/components/fields/ReadOnlyDetail";
import ReadOnlyDetails from "@src/components/ReadOnlyDetails";
import { type GQLCodeAdminQuery } from "@src/graphql.generated";
import { type FC, type PropsWithChildren, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { DeleteCodeButtonIcon } from "./CodeInformation.sc";

const CodeInformation: FC<PropsWithChildren<GQLCodeAdminQuery>> = ({ licenceAdmin }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const intl = useIntl();
    const { activatedAt, code, activeFrom, activeTill, package: licencePackage, createdAt, type } = licenceAdmin;

    function handleDialogOpen() {
        setDialogOpen(true);
    }

    function handleDialogClose() {
        setDialogOpen(false);
    }

    return (
        <>
            <DeleteCodeDialog
                open={dialogOpen}
                handleClose={handleDialogClose}
                licenceId={licenceAdmin.id}
                title={<FormattedMessage id="reviermanager.common.code.delete.title" defaultMessage="Code löschen" />}
                dialogBody={
                    <StyledTypography>
                        <FormattedMessage
                            id="reviermanager.common.code.delete"
                            defaultMessage="Möchten Sie den Code {licenceCode} wirklich löschen?"
                            values={{ licenceCode: licenceAdmin.code }}
                        />
                    </StyledTypography>
                }
            />
            <ReadOnlyDetails title={intl.formatMessage({ id: "reviermanager.codes.detail.title", defaultMessage: "Code-Details" })}>
                <ReadOnlyDetailField value={code} label={intl.formatMessage({ id: "reviermanager.codes.code", defaultMessage: "Code" })} />
                <ReadOnlyDetailField
                    value={licencePackage.name}
                    label={intl.formatMessage({ id: "reviermanager.codes.package.name", defaultMessage: "Paket" })}
                />
                <ReadOnlyDetailField
                    value={
                        activatedAt
                            ? intl.formatMessage({ id: "reviermanager.codes.activatedAt.yes", defaultMessage: "ja" })
                            : intl.formatMessage({ id: "reviermanager.codes.activatedAt.no", defaultMessage: "nein" })
                    }
                    label={intl.formatMessage({ id: "reviermanager.codes.activatedAt", defaultMessage: "eingelöst?" })}
                />
                <ReadOnlyDetailField value={type} label={intl.formatMessage({ id: "reviermanager.codes.type", defaultMessage: "Typ" })} />
                <ReadOnlyDetailField
                    type="date"
                    value={createdAt}
                    label={intl.formatMessage({ id: "reviermanager.codes.createdAt", defaultMessage: "Erstellt am" })}
                />
                <ReadOnlyDetailField
                    type="date"
                    value={activeFrom}
                    label={intl.formatMessage({ id: "reviermanager.codes.activeFrom", defaultMessage: "Lizenz aktiviert am" })}
                />
                <ReadOnlyDetailField
                    type="date"
                    value={activeTill}
                    label={intl.formatMessage({ id: "reviermanager.codes.activeTill", defaultMessage: "Lizenz läuft ab am" })}
                />
                <DetailAction onClick={handleDialogOpen} icon={<DeleteCodeButtonIcon />}>
                    <FormattedMessage id="reviermanager.codes.detail.delete" defaultMessage="Code löschen" />
                </DetailAction>
            </ReadOnlyDetails>
        </>
    );
};
export default CodeInformation;
